import Route from "vue-routisan";
import vuex from "@/vuex";
import isAuthenticated from "../middlewares/isAuthenticated";
import isFourPl from "../middlewares/isFourPl";
import hasIntegraPermission from "@/http/routes/middlewares/hasPermission/hasIntegraPermission";

Route.group({}, () => {
  Route.group({prefix: "logistic_manager", beforeEnter: [isAuthenticated,hasIntegraPermission]}, () => {

    Route.group({prefix: "four_pl", beforeEnter: [isFourPl]}, () => {

      Route.redirect("/", to => {
        return {name: "four_pl.dashboard"};
      });

      Route.view("/dashboard", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/Dashboard/Dashboard.vue")
      ).name("four_pl.dashboard");

      Route.view("/control_tower", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/Dashboard/ControlTower.vue")
      ).name("four_pl.control_tower");

      Route.view("/order_in_progress", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/Dashboard/OrderInProgress.vue")
      ).name("four_pl.order_in_progress");

      Route.group({prefix: "user"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/user/UserList")
        ).name("four_pl.user");
        Route.view("/create", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/user/UserCreate")
        ).name("four_pl.user_create");
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/user/UserUpdate")
        ).name("four_pl.user_update");
      });

      Route.group({prefix: "shippers"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/shippers/ShipperList.vue")
        ).name("four_pl.shippers");
        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/shippers/ShipperDetails.vue")
        ).name("four_pl.shippers_details");
      });

      Route.group({prefix: "transporters"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/transporters/TransporterList.vue")
        ).name("four_pl.transporters");
        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/transporters/TransporterDetails.vue")
        ).name("four_pl.transporters_details");
      });

      Route.view("/order", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/OrderList")
      ).name("four_pl.order");

      Route.view("/order", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/OrderList")
      ).name("four_pl.order");

      Route.view("/orders/documents", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/OrdersDocuments")
      ).name("four_pl.orders_documents");

      Route.view("/exports", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/fourPl/order/Exports")
      ).name("four_pl.orders_exports");


      Route.view("/import_cte", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/components/ImportCte/CteImport")
      ).name("four_pl.import_cte");

      Route.view("/order/create", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/OrderCreate")
      ).name("four_pl.order_create");

      Route.view("/order/update/:id", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/OrderUpdate")
      ).name("four_pl.order_update");

      Route.view("order/canceled", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/OrderCanceledList")
      ).name("four_pl.order_canceled");

      Route.view("order/canceled/:id", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/OrderCanceledDetails")
      ).name("four_pl.order_canceled_details");

      Route.view("/simulation", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/SimulationIntegra")
      ).name("four_pl.order_simulation");

      Route.view("/shipping_request_quote", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/ShippingRequestQuote")
      ).name("four_pl.order_shipping_request_quote");

      Route.view("/simulation/approve_table", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/SimulationIntegraApproveTable")
      ).name("four_pl.simulation.approve_table");

      Route.view("/approve_route_table", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/ApproveRouteTable")
        ).name("four_pl.approve_route_table");

      Route.group({prefix: "driver"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/driver/DriverList")
        ).name("four_pl.driver");

        Route.view("/create", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/driver/DriverCreate")
        ).name("four_pl.driver_create");

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/driver/DriverUpdate")
        ).name("four_pl.driver_update");
      });

      Route.view("/customer", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/customers/CustomerList")
      ).name("four_pl.customer");

      Route.view("/customer/create", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/customers/CustomerCreate")
      ).name("four_pl.customer_create");

      Route.view("/customer/update/:id", () =>
        import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/customers/CustomerUpdate")
      ).name("four_pl.customer_update");

      Route.group({prefix: "purchase_order"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/purchaseOrder/PurchaseOrderList")
        ).name("four_pl.purchase_order")

        Route.view("/create", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/purchaseOrder/PurchaseOrderCreate")
        ).name("four_pl.purchase_order_create")

        Route.view("/exports", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/export/PrePurchaseOrderReport")
        ).name("four_pl.purchase_order_exports")

        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/purchaseOrder/PurchaseOrderDetails")
        ).name("four_pl.purchase_order_details")

        Route.view("/board", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/purchaseOrder/PurchaseOrderBoard")
        ).name("four_pl.purchase_order_board");

      });

      Route.group({prefix: "imports"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/import/ReportImport")
        ).name("four_pl.imports");
      });

      Route.group({prefix: "export"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/export/OrderExport")
        ).name("four_pl.order_export");
        Route.view("/reports", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/export/OrderReport")
        ).name("four_pl.order_reports");
        Route.view("/orders_documents", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/export/OrdersDocumentsExport")
        ).name("four_pl.orders_documents_export");
        Route.view("/transporters", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/export/TransportersExport")
        ).name("four_pl.transporters_export");
      });

      Route.group({prefix: "invoice"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/invoice/CanhotoList")
        ).name("four_pl.canhoto")
        Route.view("/nf_files", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/invoice/NfList")
        ).name("four_pl.nf_files")
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               QUOTES                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "quotes"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/order/OrderQuotes")
        ).name("four_pl.order_quotes");
        Route.view("/:id", () =>
          import(/* webpackChunkName: "v" */ "@/resources/views/logistic_manager/fourPl/order/QuoteDetails")
        ).name("four_pl.order_quotes_details");
        Route.view("/transporters/:id", () =>
          import(/* webpackChunkName: "v" */ "@/resources/views/logistic_manager/fourPl/order/QuoteDetailsTransporters")
        ).name("four_pl.order_quotes_details_transporters");
      });

      Route.view("/ctes", () =>
        import(/* webpackChunkName: "v" */ "@/resources/views/logistic_manager/fourPl/invoice/ListCte")
      ).name("four_pl.list_cte");

      Route.group({prefix: "address"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/address/AddressAliasList")
        ).name("four_pl.address_alias")
        Route.view("/create", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/address/AddressAliasCreate")
        ).name("four_pl.address_alias_create")
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/address/AddressAliasUpdate")
        ).name("four_pl.address_alias_update")
      });


      /*---------------------------------------------------------------------------------------------------------------
      |                                               REQUEST                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "request"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/request/Request.vue")
        ).name("four_pl.request");
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               ROAD MAP                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "road_map"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/roadMap/RoadMap.vue")
        ).name("four_pl.road_map");
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "four_pl" */ "@/resources/views/logistic_manager/fourPl/roadMap/RoadMapUpdate.vue")
        ).name("four_pl.road_map_update");
      });
    });

  });

});

export default Route.all();
